import * as React from 'react';
import Col from '../../components-v2/Col';
import Row from '../../components-v2/Row';
import ConfigButton from '../PSConfigure/ConfigButton';
import { IntegrationContext } from '../../utils/context';
import ResetConfigModalWrapper from '../ResetConfig';
import { featureFlags } from '../../utils/featureFlags';
import apiClient from '../../utils/apiClient';
import { Spin } from 'antd'; // ✅ Add missing import

const SftpConfigure = (): React.ReactElement => {
  const { districtAlias, userFullName, isCleverIntegration } = React.useContext(IntegrationContext);
  const [showResetConfig, setShowResetConfig] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const fetchConnectionStatus = React.useCallback(async () => {
    try {
      const { data: meta } = await apiClient.get(`/data-ingest/sis/tenant-meta`);
      if (meta && meta.sisIntegration !== 'oneRoster' && meta.clientId) {
        setShowResetConfig(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [districtAlias]);

  React.useEffect(() => {
    fetchConnectionStatus();
  }, [fetchConnectionStatus]);

  if (loading) {
    return (
      <div className="spinner" data-testid="loading-spinner">
        <Spin size="large" />
      </div>
    );
  }

  if (showResetConfig) {
    return (
      <ResetConfigModalWrapper
        author={userFullName}
        integrationType={isCleverIntegration ? 'clever' : 'oneRoster'}
        setTTLFlag={featureFlags['feature.dataIngest.reset.setTTL']}
        setShowResetConfig={setShowResetConfig}
      />
    );
  }

  return (
    <div>
      <p>
        Complete <b>SFTP setup</b> before any data upload using SFTP
      </p>
      <Row>
        <Col span={20}>
          <ConfigButton id="sis_integration_setup" to="/sftp">
            Configure SFTP
          </ConfigButton>
          <p className="configText" data-test-id="ps_sftp_configure">
            Review and copy SFTP settings to your SFTP tool.
          </p>
        </Col>
      </Row>
      { featureFlags['feature.dataIngest.oneRosterImportSettingsPage'] && (<Row>
        <Col span={20}>
          <ConfigButton id="sis_integration_setup" to="/configure/upload">
            OneRoster format settings
          </ConfigButton>
          <p className="configText" data-test-id="ps_one_roster_import_settings">
            Upload the source file and map your schools.
          </p>
        </Col>
      </Row>)}
      <Row>
        <Col span={20}>
          <ConfigButton
            id="sis_integration_setup"
            to={
              featureFlags['feature.dataIngest.oneRosterImportSettingsPage']
                ? '/configure/import-settings'
                : '/import-wizard/oneroster/staff/upload-file'
            }
          >
            OneRoster import settings
          </ConfigButton>
          <p className="configText" data-test-id="ps_one_roster_import_settings">
            Import settings for connection between Naviance and SIS through OneRoster.
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default SftpConfigure;
